import gql from 'graphql-tag';

export const getApplication = gql`
  query getActiveApplication {
    getActiveApplication {
      applicationId
      applicationStatus
      metaData {
        acceptedQuote {
          id
          erpQuoteRef
        }
        quoteId
        creditCheckId
        creditCheckCompleted
        creditCheckStatus
        quotes
        customerOptions
        hrApprovalRequestSent
        hrApproval
      }
    }
  }
`;

export const clearApplication = gql`
  mutation clearActiveApplication {
    clearActiveApplication {
      status
    }
  }
`;
